/**
 * Modelnaam met profielfoto (04-10-2026, Jordy: "overal de foto erbij").
 *
 * Geef een slug of een profiel-id (en eventueel de naam die de pagina al
 * heeft); de foto komt uit de gedeelde modellenlijst (lib/modellen). Zonder
 * foto blijft het de gekleurde initiaal, zoals nu.
 */
import { Avatar } from './ui'
import { useModellen } from '../lib/modellen'

export function ModelNaam({
  slug,
  id,
  naam,
  size,
  vet = false,
}: {
  slug?: string | null
  id?: number | null
  naam?: string | null
  size?: number
  /** Naam vet, zoals in de meeste tabellen de eerste kolom. */
  vet?: boolean
}) {
  const { zoek } = useModellen()
  const p = zoek(id ?? slug ?? naam ?? null)
  // Sommige routes geven de slug als "naam" (bv. top-spenders: f2f_rozy); dan
  // liever de artiestennaam van dat profiel.
  const naamIsSlug = !!(p && naam && naam.toLowerCase() === p.slug.toLowerCase())
  const tekst = (naamIsSlug ? (p?.stage_name || p?.name) : naam)
    || p?.stage_name || p?.name || slug || (id != null ? `#${id}` : '—')
  const inhoud = <><Avatar name={tekst} src={p?.avatar_url} size={size} />{tekst}</>
  return vet ? <b>{inhoud}</b> : <span>{inhoud}</span>
}
